import React, { useState } from 'react';
import {
  Box, Button, FormControl, FormLabel, Input, VStack, Text,
  Heading, useToast, Flex,
} from '@chakra-ui/react';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const csrftoken = getCookie('csrftoken');

    try {
      const response = await fetch('/api/v1/auth/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        onLogin(data.token);
      } else {
        toast({ title: 'Invalid credentials', status: 'error', duration: 3000, isClosable: true });
      }
    } catch (err) {
      toast({ title: 'Login failed', status: 'error', duration: 3000, isClosable: true });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <Box
        bg="white"
        p={10}
        borderRadius="2xl"
        boxShadow="xl"
        w="full"
        maxW="400px"
      >
        <VStack spacing={6}>
          <Flex direction="column" align="center" mb={2}>
            <Box
              w={20}
              h={20}
              borderRadius="full"
              overflow="hidden"
              bg="teal.500"
              p={1}
              mb={4}
              boxShadow="lg"
            >
              <img src="/static/selwyn-logo.png" alt="Selwyn" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
            </Box>
            <Heading size="lg" color="gray.800">Selwyn Meet</Heading>
            <Text color="gray.500" fontSize="sm" mt={1}>Admin Panel</Text>
          </Flex>

          <form onSubmit={handleLogin} style={{ width: '100%' }}>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Username</FormLabel>
                <Input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  focusBorderColor="teal.400"
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  focusBorderColor="teal.400"
                />
              </FormControl>
              <Button
                type="submit"
                colorScheme="teal"
                isLoading={isLoading}
                w="full"
                size="lg"
              >
                Sign In
              </Button>
            </VStack>
          </form>
        </VStack>
      </Box>
    </Flex>
  );
}
